
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import languages from './languages.json'
import { auth } from '../firebase'
import router from '../router/index'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        auth: {
            isAuth: false,
        },

        init_state: false,
        languages: languages,
        language: languages[0],
        
        patients_list: [],
        
        record_tests_list: [],
        
        records_list: [],
        
        tests_list: [],
        
        units_list: [],
        
    },
    getters: {
        language: state => state.language,
        languages: state => state.languages,
        auth: state => state.auth,

        patients_list: state => state.patients_list,
        
        record_tests_list: state => state.record_tests_list,
        
        records_list: state => state.records_list,
        
        tests_list: state => state.tests_list,
        
        units_list: state => state.units_list,
        
    },
    mutations: {
        setAuth(state, payload) {
            state.auth.user = payload.user
            state.auth.isAuth = true
            localStorage.setItem('auth', JSON.stringify(auth))
        },
        setLanguage(state, language) {
            state.language = language
        },
        
        setPatientsList(state, patients_list) {
            state.patients_list = patients_list
        },
        
        setRecordTestsList(state, record_tests_list) {
            state.record_tests_list = record_tests_list
        },
        
        setRecordsList(state, records_list) {
            state.records_list = records_list
        },
        
        setTestsList(state, tests_list) {
            state.tests_list = tests_list
        },
        
        setUnitsList(state, units_list) {
            state.units_list = units_list
        },
        
    },
    actions: {
        init(context) {

            // const id = 'yn5lsqU1MwZPOPfSAUR7tmQ8be82'
            axios.get('init/')
                .then(r => {
                    if (r.status == 200 && r.data) {
                        context.commit('setAuth', {
                        })
                        context.commit('setPatientsList', r.data.patients)
                        context.commit('setUnitsList', r.data.units)
                        context.commit('setTestsList', r.data.tests)
                        context.commit('setRecordsList', r.data.records)
                        context.commit('setRecordTestsList', r.data.record_tests)
                        context.state.init_state = true
                        // set auth

                        
                    } else {

                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        logout(context) {
            auth.signOut()
            localStorage.removeItem('auth')
            context.state.auth.isAuth = false
            router.push('/login')
            context.state.init_state = true
        },
    },
})
        